// extracted by mini-css-extract-plugin
export default {"container":"TempContextManagementPage_container__54QTo","title":"TempContextManagementPage_title__LDp9V"};